import {Selectors} from '../Settings';
import Slider from '../../../../../../ig_gallery/Resources/Public/Src/Js/Elements/Slider';

/**
 * Testimonials
 */
export default class Testimonials extends Slider {
    constructor($testimonialsSelector) {
        super($testimonialsSelector);

        this.$testimonialsSelector = $testimonialsSelector;
        this.initialize({
			items: 1,
			animateIn: 'fadeIn',
			animateOut: 'fadeOut',
			mouseDrag: false,
			touchDrag: false,
			autoplay: true,
			autoplayHoverPause: true,
			loop: true,
			dots: true
        });
    }
}